module.exports = __webpack_public_path__ + "media/images/v1/thumb1-3b0d2e74f03c714deab9f58548f9fec4.png";